import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import DashboardHeader from './Header';
import { UserProvider, useUser } from '../Usercontext'; 
import OnboardingPopover from './OnboardingPopover';
import axios from 'axios';
import config from '../config';
import { json } from 'stream/consumers';

const DashboardContent: React.FC = () => {
  const { isOnboarded, setIsOnboarded } = useUser();

  useEffect(() => {
    
    
    // checkOnboarding();
    // No need to call an API for onboaring status check as you are already saving it in local storage just get it from there as we did orignally when we started on this project
    const isOnboarded = localStorage.getItem('userSession');
    const isUserOnboarded = isOnboarded ? JSON.parse(isOnboarded).is_onboarded : false;

    setIsOnboarded(isUserOnboarded)

  }, [setIsOnboarded]);

  return (
    <div className="container">
      {!isOnboarded && <OnboardingPopover />}
      <Sidebar />
      <div className="main-content">
        <DashboardHeader />
        <main>
          <Outlet /> {/* Nested routes will render here */}
        </main>
      </div>
    </div>
  );
};

const DashboardLayout: React.FC = () => {
  console.log("DashboardLayout rendering, about to render Outlet");

  return (
    <UserProvider>
      <DashboardContent />
    </UserProvider>
  );
};

export default DashboardLayout;
